import { currentRoomContext, TCurrentJackpotRoom } from '@views/jackpot';
import { useContext } from 'react';

export default function useJackpotRoom(): {
    currentRoom: TCurrentJackpotRoom;
    /* eslint-disable no-unused-vars */
    setRoom: (room: TCurrentJackpotRoom) => void;
} {
    const { currentRoom, setRoom } = useContext(currentRoomContext);
    return {
        currentRoom,
        setRoom,
    };
}
